import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantStateData', breakStockOutByCustomerItem: boolean, produceProductionEntryReview: boolean, created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, purchaseOrderReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, effectivePurchaseOrderReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceAutoLinkMatchingNumbers: boolean, produceQuantityDecimals: number, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null };

export type GetStockByCustomerItemDisablePreviewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStockByCustomerItemDisablePreviewQuery = { __typename?: 'Query', stockByCustomerItemDisablePreview?: { __typename?: 'StockByCustomerItemDisablePreview', heldQuantity: number } | null };

export type GetTenantBillsThroughErpQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantBillsThroughErpQuery = { __typename?: 'Query', tenantBillsThroughErp: boolean };

export type GetOnlineInvoicePaymentsEnabledQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOnlineInvoicePaymentsEnabledQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantStateData', onlineInvoicePaymentsEnabled: boolean } | null };

export type TenantDetailsFragment = { __typename?: 'TenantStateData', breakStockOutByCustomerItem: boolean, produceProductionEntryReview: boolean, created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, purchaseOrderReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, effectivePurchaseOrderReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceAutoLinkMatchingNumbers: boolean, produceQuantityDecimals: number, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> };

export type TenantGradeLabelFragment = { __typename?: 'TenantGradeLabelData', grade: number, label: string };

export type GetFernieSuggestionsSettingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFernieSuggestionsSettingQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantStateData', tenantId: string, fernieSuggestionsOn: boolean, fernieSuggestionsEnabled: boolean } | null };

export type FernieSuggestionsSettingFragment = { __typename?: 'TenantStateData', tenantId: string, fernieSuggestionsOn: boolean, fernieSuggestionsEnabled: boolean };

export const TenantGradeLabelFragmentDoc = new TypedDocumentString(`
    fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}
    `, {"fragmentName":"TenantGradeLabel"});
export const TenantDetailsFragmentDoc = new TypedDocumentString(`
    fragment TenantDetails on TenantStateData {
  breakStockOutByCustomerItem
  produceProductionEntryReview
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  purchaseOrderReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  effectivePurchaseOrderReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceAutoLinkMatchingNumbers
  produceQuantityDecimals
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
    fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`, {"fragmentName":"TenantDetails"});
export const FernieSuggestionsSettingFragmentDoc = new TypedDocumentString(`
    fragment FernieSuggestionsSetting on TenantStateData {
  tenantId
  fernieSuggestionsOn
  fernieSuggestionsEnabled
}
    `, {"fragmentName":"FernieSuggestionsSetting"});
export const GetTenantDocument = new TypedDocumentString(`
    query GetTenant {
  tenant {
    ...TenantDetails
  }
}
    fragment TenantDetails on TenantStateData {
  breakStockOutByCustomerItem
  produceProductionEntryReview
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  purchaseOrderReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  effectivePurchaseOrderReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceAutoLinkMatchingNumbers
  produceQuantityDecimals
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const GetStockByCustomerItemDisablePreviewDocument = new TypedDocumentString(`
    query GetStockByCustomerItemDisablePreview {
  stockByCustomerItemDisablePreview {
    heldQuantity
  }
}
    `);
export const GetTenantBillsThroughErpDocument = new TypedDocumentString(`
    query GetTenantBillsThroughErp {
  tenantBillsThroughErp
}
    `);
export const GetOnlineInvoicePaymentsEnabledDocument = new TypedDocumentString(`
    query GetOnlineInvoicePaymentsEnabled {
  tenant {
    onlineInvoicePaymentsEnabled
  }
}
    `);
export const GetFernieSuggestionsSettingDocument = new TypedDocumentString(`
    query GetFernieSuggestionsSetting {
  tenant {
    ...FernieSuggestionsSetting
  }
}
    fragment FernieSuggestionsSetting on TenantStateData {
  tenantId
  fernieSuggestionsOn
  fernieSuggestionsEnabled
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenant: build.query<GetTenantQuery, GetTenantQueryVariables | void>({
      query: (variables) => ({ document: GetTenantDocument, variables })
    }),
    GetStockByCustomerItemDisablePreview: build.query<GetStockByCustomerItemDisablePreviewQuery, GetStockByCustomerItemDisablePreviewQueryVariables | void>({
      query: (variables) => ({ document: GetStockByCustomerItemDisablePreviewDocument, variables })
    }),
    GetTenantBillsThroughErp: build.query<GetTenantBillsThroughErpQuery, GetTenantBillsThroughErpQueryVariables | void>({
      query: (variables) => ({ document: GetTenantBillsThroughErpDocument, variables })
    }),
    GetOnlineInvoicePaymentsEnabled: build.query<GetOnlineInvoicePaymentsEnabledQuery, GetOnlineInvoicePaymentsEnabledQueryVariables | void>({
      query: (variables) => ({ document: GetOnlineInvoicePaymentsEnabledDocument, variables })
    }),
    GetFernieSuggestionsSetting: build.query<GetFernieSuggestionsSettingQuery, GetFernieSuggestionsSettingQueryVariables | void>({
      query: (variables) => ({ document: GetFernieSuggestionsSettingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantQuery, useLazyGetTenantQuery, useGetStockByCustomerItemDisablePreviewQuery, useLazyGetStockByCustomerItemDisablePreviewQuery, useGetTenantBillsThroughErpQuery, useLazyGetTenantBillsThroughErpQuery, useGetOnlineInvoicePaymentsEnabledQuery, useLazyGetOnlineInvoicePaymentsEnabledQuery, useGetFernieSuggestionsSettingQuery, useLazyGetFernieSuggestionsSettingQuery } = injectedRtkApi;
